// import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import PropTypes from 'prop-types';
// import { List, ListItemIcon } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useSelector, shallowEqual } from 'react-redux';
// import { Link } from 'react-router-dom';
// import { getMenuIcon } from './menuIcons';
// import ListMenuLevel from '../../components/general/ListMenuLevel';
// import useMenuTree from '../../hooks/useMenuTree';
// import useRouteMatch from '../../hooks/useRouteMatch';
// import { setActiveMenu,closeSecondaryMenu } from '../../store/features/secondaryMenuSlice';
// import { useDispatch } from 'react-redux';
// import { clearAllPaginationState } from '../../utils/helpers';

// function MainMenu() {
//   const theme = useTheme();
//   const menus = useSelector((state) => state.menu.roleWiseData.menus, shallowEqual);
//   const { topLevelItems, getChildren } = useMenuTree(menus);
//   const { isActive } = useRouteMatch();
//   const dispatch = useDispatch();

//   const handleClick = (drawerId, isCollapse, isSubmenu) => {
//     clearAllPaginationState();

//     dispatch(
//       setActiveMenu({
//         activeMenuId: drawerId,
//         isSecondaryMenuOpen: isCollapse,
//         hasSubmenu: isSubmenu,
//       }),
//     );
//     // dispatch(closeSecondaryMenu())
//   };

//   return (
//     <List>
//       {topLevelItems.map((item) => {
//         const active = isActive(item);
//         const { filled: FilledIcon, line: LineIcon } = getMenuIcon(item.display_icon);
//         const hasChildren = getChildren(item._id).length > 0;

//         return (
//           <div key={item._id}>
//             <Link
//               to={item.url ? item.url : '/not-found'}
//               style={{
//                 textDecoration: 'inherit',
//                 color: 'inherit',
//               }}
//             >
//               <ListMenuLevel
//                 selected={active}
//                 ListItemText={item?.name}
//                 onClick={() =>
//                   handleClick(item._id, hasChildren, hasChildren)
//                 }              >
//                 <ListItemIcon
//                   sx={{
//                     color: theme.palette.common.white,
//                     minWidth: 36,
//                   }}
//                   className="me-0"
//                 >
//                   {active ? (
//                     <FilledIcon
//                       style={{
//                         color: theme.palette.primary.main,
//                       }}
//                     />
//                   ) : (
//                     <LineIcon style={{ color: 'inherit' }} />
//                   )}
//                 </ListItemIcon>
//               </ListMenuLevel>
//             </Link>
//           </div>
//         );
//       })}
//     </List>
//   );
// }

// export default MainMenu;

import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { List, ListItemIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector, shallowEqual } from "react-redux";
// 1. useLocation import karo (jo pehla thi na hoy to)
import { Link, useLocation } from "react-router-dom";
import { getMenuIcon } from "./menuIcons";
import ListMenuLevel from "../../components/general/ListMenuLevel";
import useMenuTree from "../../hooks/useMenuTree";
import useRouteMatch from "../../hooks/useRouteMatch";
import {
  setActiveMenu,
  closeSecondaryMenu,
} from "../../store/features/secondaryMenuSlice";
import { useDispatch } from "react-redux";
import { clearAllPaginationState } from "../../utils/helpers";

function MainMenu() {
  const theme = useTheme();
  const menus = useSelector(
    (state) => state.menu.roleWiseData.menus,
    shallowEqual,
  );
  const { topLevelItems, getChildren } = useMenuTree(menus);
  const { isActive } = useRouteMatch();
  const dispatch = useDispatch();

  const location = useLocation();

  const handleClick = (drawerId, isCollapse, isSubmenu) => {
    clearAllPaginationState();

    dispatch(
      setActiveMenu({
        activeMenuId: drawerId,
        isSecondaryMenuOpen: isCollapse,
        hasSubmenu: isSubmenu,
      }),
    );
  };

  return (
    <List>
      {topLevelItems.map((item) => {
        const hasChildren = getChildren(item._id).length > 0;


        const isEslModule = item.alias_name === "esl_tag_management";
        const isEslPath = location.pathname.startsWith("/esl-tag-management");

        const active = (isEslModule && isEslPath) || isActive(item);

        const { filled: FilledIcon, line: LineIcon } = getMenuIcon(
          item.display_icon,
        );

        return (
          <div key={item._id}>
            <Link
              to={item.url ? item.url : "/not-found"}
              style={{
                textDecoration: "inherit",
                color: "inherit",
              }}
            >
              <ListMenuLevel
                selected={active}
                ListItemText={item?.name}
                onClick={() => handleClick(item._id, hasChildren, hasChildren)}
              >
                <ListItemIcon
                  sx={{
                    color: theme.palette.common.white,
                    minWidth: 36,
                  }}
                  className="me-0"
                >
                  {active ? (
                    <FilledIcon
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <LineIcon style={{ color: "inherit" }} />
                  )}
                </ListItemIcon>
              </ListMenuLevel>
            </Link>
          </div>
        );
      })}
    </List>
  );
}

export default MainMenu;
